// src/Logout.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('token');
        document.cookie = 'ak_logged_in=; Path=/; Max-Age=0; Secure; SameSite=Lax'
        // alert('ログアウトしました');
        navigate('/login');
    }, [navigate]);

    return null;
}

export default Logout;
